import './index.css';
import Head from "components/cobrand/Head";
import {buyeeUrl, imageUrl} from "utils/url";
import SearchForm from "components/cobrand/SearchForm";
import VideoModal from "components/cobrand/VideoModal";
import NewItems from "components/cobrand/NewItems";
import PopularCategories from "components/cobrand/PopularCategories";
import Notices from "components/cobrand/Notices";
import {gaBodyScript} from "utils/ga";
import {chatTagScript} from "utils/chatTag";
import {BottomBanner, FollowBanner, MainBanner} from "components/cobrand/Banners";
import {useEffect, useRef, useState} from "react";
import axios from "axios";
import Trends from "components/cobrand/Trends";

function Index() {
  // バナー取得
  const [banners, setBanners] = useState({main: {}, follow: {}, bottom: {}});
  useEffect(() => {
    axios
      .get('files/cobrand/banners.json')
      .then(response => {
        setBanners(response.data);
      });
  }, []);

  // メインバナーが画面にない時にのみ追尾バナーを表示する
  const [showFollowBanner, setShowFollowBanner] = useState(false);
  const mainBannerRef = useRef("mainBanner");
  useEffect(() => {
    window.addEventListener('scroll', e => {
      const windowTop = window.scrollY;
      const mainBannerBottom = mainBannerRef.current.offsetTop + mainBannerRef.current.clientHeight;
      setShowFollowBanner(windowTop > mainBannerBottom);
    });
  }, []);

  return (
    <>
      <Head/>

      <div>
        {gaBodyScript()}

        {/* ヘッダー */}
        <header className="width-full tw-header">
          <nav className="tw-header__nav display-none--xs">
            <ul className="width-max list">
              <li><a href="https://tw.bid.yahoo.com/tw?skin=index" target="_blank">
                <img src="https://cdn.buyee.jp/images/cobrand/common/home.svg" alt="首頁" width="16" height="16"/>
                <span>首頁</span>
              </a></li>
              <li><a href="https://tw.buy.yahoo.com/" target="_blank"><span>購物中心</span></a></li>
              <li><a href="https://tw.billing.yahoo.com/mybilling/" target="_blank"><span>帳務中心</span></a></li>
            </ul>
          </nav>
          <div className="tw-header__cobrand">
            <ul className="logos">
              <li className="logos--yahoo">
                <p>
                  <a href="https://tw.bid.yahoo.com/" target="_blank">
                    <img src="https://buyee.jp/images/cobrand/common/logo_yahoo.png" alt="Yahoo!奇摩拍賣" className="logo"/>
                  </a>
                </p>
                <p className="txt-sponsor display-none--s">以下内容
                  <a href="https://buyee.jp/?lang=cht&rc=twy_cobrand_entry&twTran=1" target="_blank" className="txt__link">Buyee</a>
                  提供,
                  <a href="https://tw.bid.yahoo.com/help/info/buyee_info.html" target="_blank" className="txt__link">詳細説明</a>
                </p>
              </li>
              <li className="crosses display-show--s"></li>
              <li className="logos--buyee">
                <p>
                  <a href="https://buyee.jp/?lang=cht&rc=twy_cobrand_entry&twTran=1" target="_blank">
                    <img src="https://buyee.jp/images/cobrand/common/logo_buyee.png" alt="Buyee" className="logo"/>
                  </a>
                </p>
              </li>
            </ul>
          </div>
        </header>

        <div ref={mainBannerRef} className="width-full tw-top">
          {/* メインバナー */}
          <MainBanner banner={banners.main}/>

          {/* 検索窓 */}
          <SearchForm/>
        </div>

        {/* 会員登録ボタン */}
        <div className="tw-btnBox">
          <a href={buyeeUrl("signup/pre?lang=cht&rc=twy_toppage_pc&twTran=1")} target="_blank" className="tw-btn">立即加入會員</a>
          <a href={"https://media.buyee.jp/pr/tw_shippingfee/cht/?rc=twy_toppage_pc&twTran=1"} target="_blank" className="tw-btn">了解更多</a>
        </div>

        {/* アニメバナー */}
        <VideoModal/>

        <section className="width-contents">
          <div className="tw-about__category">

            {/* 話題熱搜（トレンド） */}
            <Trends/>

            {/* 新着商品 */}
            <NewItems/>

            {/* 人気分類（人気カテゴリ） */}
            <PopularCategories/>
          </div>
        </section>

        {/* 会員登録ボタン */}
        <div className="tw-btnBox">
          <a href={buyeeUrl("signup/pre?lang=cht&rc=twy_toppage_pc&twTran=1")} target="_blank" className="tw-btn">立即加入會員</a>
          <a href={buyeeUrl("yahoo/auction?lang=cht&rc=twy_toppage_pc&twTran=1")} target="_blank" className="tw-btn">看更多日本夯品</a>
        </div>

        {/* 購買須知（お知らせ） */}
        <Notices/>

        {/* 利用方法 */}
        <section className="tw-about width-contents">
          <h2 className="title__regular">
            <img src={imageUrl('cobrand/common/tw_service_title01.png')} alt="Buyee是Yahoo! JAPAN Auction官方合作夥伴"/>
          </h2>
          <div className="tw-about__introduction">
            <p className="introduction__catch">
              <img src={imageUrl('cobrand/common/tw_about_txt.png')} alt="評價最佳、價格最透明 台灣用戶回購率90%代購服務網站"/>
            </p>
            <ul className="introduction__merit">
              <li><img src={imageUrl('cobrand/common/tw_about_icon01.png')} alt="可用信用卡"/></li>
              <li><img src={imageUrl('cobrand/common/tw_about_icon02.png')} alt="免加值"/></li>
              <li><img src={imageUrl('cobrand/common/tw_about_icon03.png')} alt="中日文對照"/></li>
              <li><img src={imageUrl('cobrand/common/tw_about_icon04.png')} alt="包裹賠付保障"/></li>
            </ul>
          </div>
          <p className="tw-about__text">以最便宜的價格，享受便利日本代購，安全送達！</p>
        </section>
        <section className="tw-list width-contents">
          <h2 className="title__regular">
            <img src={imageUrl('cobrand/common/tw_service_title02.png')} alt="代購費用比較"/>
          </h2>
          <div className="tw-recommendArea">
            <div className="tw-recommendArea__item">
              <div className="tw-recommendArea__title">
                <p>超划算亮點<span className="tw-recommendArea__point">1</span></p>
                <h2 className="tw-recommendArea__heading"><span>代購手續費為代購業界最低價</span></h2>
              </div>
              <p>代購手續費一率300日元(約85元新台幣)<br/>業界壓倒性的划算價格</p>
              <p><img src={imageUrl('cobrand/common/graph01.png')} alt="M社=250NTD L社=200NTD Buyee=85NTD 業界最便宜"/></p>
            </div>
            <div className="tw-recommendArea__item">
              <div className="tw-recommendArea__title">
                <p>超划算亮點<span className="tw-recommendArea__point">2</span></p>
                <h2 className="tw-recommendArea__heading"><span>國際運費也是代購業界最低價</span></h2>
              </div>
              <p>選擇Buyee、國際運費也是最便宜</p>
              <p><img src={imageUrl('cobrand/common/graph02.png')} alt="Buyee 1公斤=238NTD 台灣限定"/></p>
              <a
                href="https://buyee.jp/help/yahoo/guide/shipping-fees?lang=cht#price_tw?rc=twy_toppage_pc&twTran=1"
                target="_blank" className="tw-recommendArea__link">→每公斤詳細的國際運費請參考這邊</a>
            </div>
          </div>
          <ul className="tw-list__textList">
            <li className="tw-list__textItem">※匯率：1日元=0.275元新台幣計算</li>
            <li className="tw-list__textItem">
              ※1 上記費用為Buyee於2021年2月由三家台灣知名代購業者公佈於官網之費用所精算出之結果（此費用不包含任何優惠等活動的變動金額）
            </li>
            <li className="tw-list__textItem">
              ※2 此處刊登之國際運費為使用Buyee空運配送方式的費用，如選擇其他配送方式，國際運費金額會有所變動
            </li>
          </ul>
        </section>
        <section className="tw-step width-contents">
          <h2 className="title__regular">
            <img src={imageUrl('cobrand/common/tw_service_title03.png')} alt="三步驟  商品直送  得標最快五天到貨"/>
          </h2>
          <ol className="tw-step__flow">
            <li className="tw-step__flowStep">
              <img className="tw-step__flowImage" src={imageUrl('cobrand/common/tw_service_step01_figure.png')} alt="搜尋商品"/>
              <div className="tw-step__flowText">
                <div className="tw-step__flowContent">
                  <span className="tw-step__flowBadge">1</span>
                  <p className="tw-step__flowTitle">搜尋商品</p>
                </div>
                <p className="tw-step__flowDescription">中日文對應<br/>簡單搜尋</p>
              </div>
            </li>
            <li className="tw-step__flowStep">
              <img className="tw-step__flowImage" src={imageUrl('cobrand/common/tw_service_step02_figure.png')} alt="中日文對應，簡單搜尋！"/>
              <div className="tw-step__flowText">
                <div className="tw-step__flowContent">
                  <span className="tw-step__flowBadge">2</span>
                  <p className="tw-step__flowTitle">Buyee為您購買收件</p>
                </div>
                <p className="tw-step__flowDescription">使用Buyee代購<br/>由日本倉庫收取包裹</p>
              </div>
            </li>
            <li className="tw-step__flowStep">
              <img className="tw-step__flowImage" src={imageUrl('cobrand/common/tw_service_step03_figure.png')} alt="中日文對應，簡單搜尋！"/>
              <div className="tw-step__flowText">
                <div className="tw-step__flowContent">
                  <span className="tw-step__flowBadge">3</span>
                  <p className="tw-step__flowTitle">安全送達</p>
                </div>
                <p className="tw-step__flowDescription">商品送達<br/>輕鬆享受代購商品</p>
              </div>
            </li>
          </ol>
          <div className="tw-step__catch">
            直送台灣累積郵寄量超過五十萬件！<br className="sp_br"/>專業值得讓人放心交付
            <p className="tw-step__catchDescription">（2021年統計數字）</p>
          </div>
        </section>

        {/* 会員登録ボタン */}
        <div className="tw-btnBox">
          <a href={buyeeUrl("signup/pre?lang=cht&rc=twy_toppage_pc&twTran=1")} target="_blank" className="tw-btn">立即加入會員</a>
          <a href={buyeeUrl("yahoo/auction?lang=cht&rc=twy_toppage_pc&twTran=1")} target="_blank" className="tw-btn">看更多日本夯品</a>
        </div>

        {/* 下部バナー */}
        <BottomBanner banner={banners.bottom}/>

        {/* 追尾バナー */}
        {showFollowBanner && <FollowBanner banner={banners.follow}/>}

        {/* フッター */}
        <footer className="width-full tw-footer">
          <div className="tw-footer__txt">
            <p>Buyee 版權所有 © 2018 Buyee All Rights Reserved.</p>
            <p>
              本服務由<a href="https://buyee.jp/?lang=cht&rc=twy_cobrand_entry&twTran=1" target="_blank" className="txt__link">Buyee</a>
              提供・<a href="https://tw.bid.yahoo.com/help/info/buyee_info.html" target="_blank" className="txt__link">詳細説明</a>
            </p>
          </div>
        </footer>

        {chatTagScript()}
      </div>
    </>
  );
}

export default Index;
